export class SubnetPerAvailabilityZone {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetId",
            "baseName": "subnetId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SubnetPerAvailabilityZone.attributeTypeMap;
    }
    constructor() {
    }
}
